<template>
  <div class="width_center_1200">
    <div class="label-list">
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text1 }}</span>
      </div>
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text2 }}</span>
      </div>
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text3 }}</span>
      </div>
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text4 }}</span>
      </div>
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text5 }}</span>
      </div>
      <div class="item">
        <svg-icon iconClass="like-block"></svg-icon>
        <span>{{ lang.text6 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    lang() {
      return this.$t('merchant_promise')
    }
  }
}
</script>

<style lang="scss" scoped>
.label-list {
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
  .item {
    display: flex;
    align-items: center;
    flex-direction: column;
    .svg-icon {
      width: 60px;
      height: 60px;
    }
    span {
      color: #4f4f4f;
      font-family: OPPOSans, OPPOSans-Bold;
      font-size: 16px;
      font-weight: 700;
      padding-top: 15px;
    }
  }
}
</style>